module.exports = __webpack_public_path__ + "static/media/IMG_0010.819ec109.jpg";